import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const BaseballRulesPage = () => {
  const rules = [
    { title: "Objectives of the Game - 1.00", link: "/objective" },
    { title: "Definition of Terms - 2.00", link: "/def" },
    { title: "Game Preliminaries - 3.00", link: "/prelim" },
    { title: "Starting & Ending Game - 4.00", link: "/starting_ending" },
    { title: "Putting the Ball in Play - 5.00", link: "/putting" },
    { title: "The Batter - 6.00", link: "/batter" },
    { title: "The Runner - 7.00", link: "/runner" },
    { title: "The Pitcher - 8.00", link: "/pitcher" },
    { title: "The Umpire - 9.00", link: "/umpire" },
    { title: "The Official Scorer - 10.00", link: "/scorer" }
  ];

  useEffect(() => {
    document.title = 'Baseball Rules | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/score-keeping">
          <div id="stick_right"></div>
        </Link>
        {/* Baseball Rules Content */}
        <div id="basic">
          <h3 className="heading3">Baseball Rules</h3>
          
          {/* Foreword Section */}
          <div style={{backgroundColor: '#f8f8f8', padding: '20px', borderRadius: '5px', marginBottom: '30px'}}>
            <h4 className="heading3">FOREWORD</h4>
            <p className="basic_p">
              This code of rules is written to govern the playing of baseball games by professional teams of the American League of Professional Baseball Clubs, the National League of Professional Baseball Clubs, and the leagues which are members of the National Association of Professional Baseball Leagues. We recognize that many amateur and non professional organizations play their games under professional rules, and we are happy to make our rules available as widely as possible. It is well to remember that specifications as to fields, equipment, etc., may be modified to meet the needs of each group. Money fines, long term suspensions and similar penalties imposed by this code are not practicable for amateur groups, but officers and umpires of such organizations should insist on strict observance of all the rules governing the playing of the game. Baseball not only has maintained its position as the National Game of the United States, but also has become an International Game being played in seventy seven countries. Its popularity will grow only as long as its players, managers, coaches, umpires and administrative officers respect the discipline of its code of rules.<br /><br />
              copy rights 1998 by the Commissioner of Baseball. All rights reserved. No part of the Official Baseball Rules may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording or any information storage and retrieval system now known or to be invented, without permission in writing from the Office of the Commissioner of Baseball. The Major League Baseball silhouetted batter logo and Major League Baseball Official Publication logo are registered trademarks of Major League Baseball Properties, Inc. OFFICIAL
            </p>
          </div>

          {/* Baseball Rules List */}
          <div style={{marginBottom: '30px'}}>
            <div className="list-group">
              <div className="list-group-item active">
                <strong>BASEBALL RULES</strong><br />
                The Official Playing Rules Committee has adopted change in Rule 2.00, Strike Zone which are underlined.
              </div>
              {rules.map((rule, index) => (
                <a key={index} href={rule.link} className="list-group-item">
                  <i className="fa fa-angle-double-right" style={{fontSize: '24px', color: '#0076a3'}}></i>
                  {' '}
                  {rule.title}
                </a>
              ))}
            </div>
          </div>

          {/* Important Note Section */}
          <div style={{backgroundColor: '#f4f9fe', padding: '20px', borderRadius: '5px'}}>
            <h4 className="heading3">IMPORTANT NOTE</h4>
            <p className="basic_p">
              The Official Playing Rules Committee at its December 1977 meeting, voted to incorporate the Notes Case Book Comments section directly into the Official Playing Rules at the appropriate places. Basically, the Case Book interprets or elaborates on the basic rules and in essence have the same effect as rules when applied to particular sections for which they are intended. This arrangement is designed to give quicker access to any written language pertaining to an Official Rule and does not require a reader to refer to different sections of the Official Playing Rules book in considering the application of a particular rule.
            </p>
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default BaseballRulesPage;